import React from 'react';
import {
  TextFields,
  RadioButtonChecked,
  ArrowDropDown,
  CheckBox,
  DateRange,
  Numbers,
  UploadFile,
  Mic,
} from '@mui/icons-material';
import { QuestionType } from '@aphp-ema/common/questionnaire';

export const getQuestionTypeIcon = (type: QuestionType) => {
  switch (type) {
    case 'text':
      return <TextFields fontSize="small" />;
    case 'radio':
      return <RadioButtonChecked fontSize="small" />;
    case 'select':
      return <ArrowDropDown fontSize="small" />;
    case 'checkboxes':
      return <CheckBox fontSize="small" />;
    case 'date':
      return <DateRange fontSize="small" />;
    case 'number':
      return <Numbers fontSize="small" />;
    case 'document':
      return <UploadFile fontSize="small" />;
    case 'voice':
      return <Mic fontSize="small" />;
    default:
      return null;
  }
};
